import { Field, Form, Formik } from 'formik'

import TextEditorField from '@/components/FormikInputs/TextEditorField'

interface TaskFormProps {
  onSubmit: (name: string, notes: string) => void
  onBlur: (name: string, notes: string, event: React.FocusEvent) => void
  onKeyDown: (name: string, notes: string, event: React.KeyboardEvent) => void
}

export const TaskForm = ({ onBlur, onKeyDown }: TaskFormProps) => {
  return (
    <Formik
      initialValues={{ name: '', notes: '' }}
      onSubmit={() => {
        /* Do Nothing */
      }}
    >
      {({ values, isSubmitting, submitForm, setFieldValue }) => (
        <Form
          onKeyDown={(event) => onKeyDown(values.name, values.notes, event)}
          onBlur={(event) => onBlur(values.name, values.notes, event)}
        >
          <div className='flex flex-col gap-4 m-4'>
            <Field
              id='name'
              name='name'
              type='text'
              placeholder='Enter Task'
              className='border p-2 w-full border-gray-200 focus:border-sky-300'
            />
            <TextEditorField
              id='notes'
              placeholder='Enter Notes'
              name='notes'
              disabled={isSubmitting}
              onChangeApplied={submitForm}
              setFieldValue={setFieldValue}
              parentClassName='border w-full border-gray-200'
            />
            <hr className='my-2' />
          </div>
        </Form>
      )}
    </Formik>
  )
}
